import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _b0b58528 = () => interopDefault(import('../pages/Home.vue' /* webpackChunkName: "" */))
const _743f62fa = () => interopDefault(import('../modules/checkout/pages/Cart.vue' /* webpackChunkName: "" */))
const _5e7b7dc0 = () => interopDefault(import('../modules/checkout/pages/Checkout.vue' /* webpackChunkName: "" */))
const _fbe2ab28 = () => interopDefault(import('../modules/checkout/pages/Checkout/Billing.vue' /* webpackChunkName: "" */))
const _20bdfc77 = () => interopDefault(import('../modules/checkout/pages/Checkout/Payment.vue' /* webpackChunkName: "" */))
const _00fe4ce6 = () => interopDefault(import('../modules/checkout/pages/Checkout/Shipping.vue' /* webpackChunkName: "" */))
const _2de2b598 = () => interopDefault(import('../modules/checkout/pages/Checkout/ThankYou.vue' /* webpackChunkName: "" */))
const _5f6bd3d3 = () => interopDefault(import('../modules/checkout/pages/Checkout/UserAccount.vue' /* webpackChunkName: "" */))
const _f3c17168 = () => interopDefault(import('../pages/Cms.vue' /* webpackChunkName: "pages/Cms" */))
const _40f70d41 = () => interopDefault(import('../modules/customer/pages/MyAccount/MyAccount.vue' /* webpackChunkName: "" */))
const _3b8a7ca2 = () => interopDefault(import('../modules/customer/pages/MyAccount/AddressesDetails/AddressesDetails.vue' /* webpackChunkName: "" */))
const _45c05b56 = () => interopDefault(import('../modules/customer/pages/MyAccount/MyNewsletter.vue' /* webpackChunkName: "" */))
const _47dbc72a = () => interopDefault(import('../modules/customer/pages/MyAccount/MyProfile/MyProfile.vue' /* webpackChunkName: "" */))
const _5f70d02f = () => interopDefault(import('../modules/customer/pages/MyAccount/MyReviews.vue' /* webpackChunkName: "" */))
const _e443a33e = () => interopDefault(import('../modules/customer/pages/MyAccount/MyWishlist.vue' /* webpackChunkName: "" */))
const _274d56ef = () => interopDefault(import('../modules/customer/pages/MyAccount/OrderHistory/OrderHistory.vue' /* webpackChunkName: "" */))
const _53f4948a = () => interopDefault(import('../modules/customer/pages/MyAccount/AddressesDetails/AddressNew.vue' /* webpackChunkName: "" */))
const _e7df622c = () => interopDefault(import('../modules/customer/pages/MyAccount/ResetPassword.vue' /* webpackChunkName: "" */))
const _0a93db02 = () => interopDefault(import('../modules/customer/pages/MyAccount/AddressesDetails/AddressEdit.vue' /* webpackChunkName: "" */))
const _3d8fc0a4 = () => interopDefault(import('../modules/customer/pages/MyAccount/OrderHistory/SingleOrder/SingleOrder.vue' /* webpackChunkName: "" */))
const _103ba299 = () => interopDefault(import('../pages/Faq.vue' /* webpackChunkName: "pages/Faq" */))
const _104b59c8 = () => interopDefault(import('../pages/Page.vue' /* webpackChunkName: "pages/Page" */))
const _5c1d7d37 = () => interopDefault(import('../modules/checkout/pages/Add.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/default",
    component: _b0b58528,
    name: "home___default"
  }, {
    path: "/german",
    component: _b0b58528,
    name: "home___german"
  }, {
    path: "/default/cart",
    component: _743f62fa,
    name: "cart___default"
  }, {
    path: "/default/checkout",
    component: _5e7b7dc0,
    name: "checkout___default",
    children: [{
      path: "billing",
      component: _fbe2ab28,
      name: "billing___default"
    }, {
      path: "payment",
      component: _20bdfc77,
      name: "payment___default"
    }, {
      path: "shipping",
      component: _00fe4ce6,
      name: "shipping___default"
    }, {
      path: "thank-you",
      component: _2de2b598,
      name: "thank-you___default"
    }, {
      path: "user-account",
      component: _5f6bd3d3,
      name: "user-account___default"
    }]
  }, {
    path: "/default/Cms",
    component: _f3c17168,
    name: "Cms___default"
  }, {
    path: "/default/customer",
    component: _40f70d41,
    meta: {"titleLabel":"My Account"},
    name: "customer___default",
    children: [{
      path: "addresses-details",
      component: _3b8a7ca2,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details___default"
    }, {
      path: "my-newsletter",
      component: _45c05b56,
      meta: {"titleLabel":"My newsletter"},
      name: "customer-my-newsletter___default"
    }, {
      path: "my-profile",
      component: _47dbc72a,
      meta: {"titleLabel":"My profile"},
      name: "customer-my-profile___default"
    }, {
      path: "my-reviews",
      component: _5f70d02f,
      meta: {"titleLabel":"My reviews"},
      name: "customer-my-reviews___default"
    }, {
      path: "my-wishlist",
      component: _e443a33e,
      meta: {"titleLabel":"My wishlist"},
      name: "customer-my-wishlist___default"
    }, {
      path: "order-history",
      component: _274d56ef,
      meta: {"titleLabel":"Order history"},
      name: "customer-order-history___default"
    }, {
      path: "addresses-details/create",
      component: _53f4948a,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details-new___default"
    }, {
      path: "/default/reset-password",
      component: _e7df622c,
      alias: "/customer/account/createPassword",
      name: "reset-password___default"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _0a93db02,
      meta: {"titleLabel":"Addresses details"},
      props: true,
      name: "customer-addresses-details-edit___default"
    }, {
      path: "order-history/:orderId",
      component: _3d8fc0a4,
      meta: {"titleLabel":"Order history"},
      props: true,
      name: "customer-single-order___default"
    }]
  }, {
    path: "/default/Faq",
    component: _103ba299,
    name: "Faq___default"
  }, {
    path: "/default/Home",
    component: _b0b58528,
    name: "Home___default"
  }, {
    path: "/default/Page",
    component: _104b59c8,
    name: "Page___default"
  }, {
    path: "/german/cart",
    component: _743f62fa,
    name: "cart___german"
  }, {
    path: "/german/checkout",
    component: _5e7b7dc0,
    name: "checkout___german",
    children: [{
      path: "billing",
      component: _fbe2ab28,
      name: "billing___german"
    }, {
      path: "payment",
      component: _20bdfc77,
      name: "payment___german"
    }, {
      path: "shipping",
      component: _00fe4ce6,
      name: "shipping___german"
    }, {
      path: "thank-you",
      component: _2de2b598,
      name: "thank-you___german"
    }, {
      path: "user-account",
      component: _5f6bd3d3,
      name: "user-account___german"
    }]
  }, {
    path: "/german/Cms",
    component: _f3c17168,
    name: "Cms___german"
  }, {
    path: "/german/customer",
    component: _40f70d41,
    meta: {"titleLabel":"My Account"},
    name: "customer___german",
    children: [{
      path: "addresses-details",
      component: _3b8a7ca2,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details___german"
    }, {
      path: "my-newsletter",
      component: _45c05b56,
      meta: {"titleLabel":"My newsletter"},
      name: "customer-my-newsletter___german"
    }, {
      path: "my-profile",
      component: _47dbc72a,
      meta: {"titleLabel":"My profile"},
      name: "customer-my-profile___german"
    }, {
      path: "my-reviews",
      component: _5f70d02f,
      meta: {"titleLabel":"My reviews"},
      name: "customer-my-reviews___german"
    }, {
      path: "my-wishlist",
      component: _e443a33e,
      meta: {"titleLabel":"My wishlist"},
      name: "customer-my-wishlist___german"
    }, {
      path: "order-history",
      component: _274d56ef,
      meta: {"titleLabel":"Order history"},
      name: "customer-order-history___german"
    }, {
      path: "addresses-details/create",
      component: _53f4948a,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details-new___german"
    }, {
      path: "/german/reset-password",
      component: _e7df622c,
      alias: "/customer/account/createPassword",
      name: "reset-password___german"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _0a93db02,
      meta: {"titleLabel":"Addresses details"},
      props: true,
      name: "customer-addresses-details-edit___german"
    }, {
      path: "order-history/:orderId",
      component: _3d8fc0a4,
      meta: {"titleLabel":"Order history"},
      props: true,
      name: "customer-single-order___german"
    }]
  }, {
    path: "/german/Faq",
    component: _103ba299,
    name: "Faq___german"
  }, {
    path: "/german/Home",
    component: _b0b58528,
    name: "Home___german"
  }, {
    path: "/german/Page",
    component: _104b59c8,
    name: "Page___german"
  }, {
    path: "/default/checkout/shipping/add",
    component: _5c1d7d37,
    name: "addproduct___default"
  }, {
    path: "/german/checkout/shipping/add",
    component: _5c1d7d37,
    name: "addproduct___german"
  }, {
    path: "/default/:slug+",
    component: _104b59c8,
    name: "page___default"
  }, {
    path: "/german/:slug+",
    component: _104b59c8,
    name: "page___german"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
